export const COMPONENT_NAME = 'DetailedDescription';
